/**
 * Tracks deltas, scaled time, and a fixed-step accumulator for
 * deterministic simulation systems (physics, network reconciliation).
 */
export class Time {
  delta = 0;
  unscaledDelta = 0;
  elapsed = 0;
  unscaledElapsed = 0;
  scale = 1;
  maxDelta = 1 / 15;
  fixedStep = 1 / 60;
  accumulator = 0;
  frame = 0;

  private last = performance.now();

  tick(now: number): void {
    const raw = (now - this.last) / 1000;
    this.last = now;
    this.unscaledDelta = raw;
    this.unscaledElapsed += raw;
    const dt = Math.min(raw, this.maxDelta) * this.scale;
    this.delta = dt;
    this.elapsed += dt;
    this.accumulator += dt;
    this.frame += 1;
  }

  /** Drain the fixed-step accumulator. Returns the alpha used for rendering interpolation. */
  consumeFixedSteps(step: (dt: number) => void): number {
    while (this.accumulator >= this.fixedStep) {
      step(this.fixedStep);
      this.accumulator -= this.fixedStep;
    }
    return this.accumulator / this.fixedStep;
  }
}
